import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { OauthLayout } from 'pages/auth/pages/oauth/layout/OauthLayout'
import { OauthPage } from 'pages/auth/pages/oauth/ui/oauthPage'

export const OauthRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<OauthLayout />}>
        <Route path={'/'} element={<OauthPage />} />
      </Route>
    </RoutesWithNotFound>
  )
}
